import React, { useCallback, useEffect } from 'react';

import { ListRenderItemInfo, View } from 'react-native';

import { useTranslation } from 'react-i18next';
import { SafeAreaView } from 'react-native-safe-area-context';

import { CloseIcon } from 'assets/images';

import { LANGUAGE_KEYS } from 'config/languageKeys';
import gStyles from 'config/styles';

import useBackHandler from 'utils/hooks/useBackHandler.ts';

import { SCREEN_PLAYER_MANAGE_RECORDING_OVERLAY_TITLE } from 'screens/Detail/languageConst';
import { ManageRecordingItem } from 'screens/Detail/types';

import SvgButton from 'components/CustomButtons/SvgButton';

import { IProps } from '../types';
import Section from './components/Section';
import SelectionOption from './components/SelectionOption';
import styles from './styles';

const { CLOSE_BUTTON } = LANGUAGE_KEYS;

function RecordingActionsOverlay({
    onRecordingItemPress,
    onClose,
    isVisible,
    recordingItems,
}: IProps) {
    const { t } = useTranslation();

    const handleBackPress = useCallback(() => {
        if (isVisible) {
            onClose();
            return true;
        }
        return false;
    }, [isVisible, onClose]);

    useBackHandler(handleBackPress);

    const renderRecordingItem = useCallback(
        ({ item }: ListRenderItemInfo<ManageRecordingItem>) => {
            return (
                <SelectionOption
                    key={item.key}
                    item={item}
                    onPress={onRecordingItemPress}
                />
            );
        },
        [onRecordingItemPress],
    );

    if (!isVisible) {
        return null;
    }

    return (
        <View style={styles.root}>
            <SafeAreaView style={styles.safeArea}>
                <View style={gStyles.flex}>
                    <View style={styles.closeContainer}>
                        <SvgButton
                            accessibilityLabel={t(CLOSE_BUTTON)}
                            accessibilityRole="button"
                            Svg={CloseIcon}
                            style={styles.close}
                            svgStyle={styles.closeSvg}
                            onPress={onClose}
                        />
                    </View>
                    <View style={styles.contentWrapper}>
                        <Section
                            title={t(
                                SCREEN_PLAYER_MANAGE_RECORDING_OVERLAY_TITLE,
                            )}
                            data={recordingItems}
                            renderItem={renderRecordingItem}
                        />
                    </View>
                </View>
            </SafeAreaView>
        </View>
    );
}

export default React.memo(RecordingActionsOverlay);
